export default {"src":"/_next/static/media/Add.ad39e391.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};